
export const atProp={
    name:"at",
    type:`"start"|"end"`,
    description:`
        Sets the element initial location.
        @- start : at the beginning of the parent
        @- end : at the end of the parent
        @default to "end"
        @For between-elements insertion, use <span>adjacentTo</span> method
    `,
},innateHTMLMethod={
    name:"innateHTML",
    type:"string",
    description:`
        Safer version of innerHTML
        @Sets safely the HTML or XML markup contained within the element.
        @Excludes <span>script</span>, <span>style</span> and <span>embed</span> elements.
        @Excludes elements that have at least one attribute starting with "on".
        @Excludes any element whose style attribute containes "javascript:"
        @Excludes any element whose href attribute does not start with ["http:","https:","data:","m-files:","file:","ftp:","mailto:","pw:"]
        @Adds <span>type</span>, <span>alt</span> and <span>sandbox</span> attributes 
        respectively to <span>button</span>, <span>img</span> and <span>iframe</span> elements.
    `,
};

export default {
    id:"View",
    parent:"HTMLElement",
    type:"(props:object):View",
    props:[
        {
            name:"parent",
            type:"HTMLElement",
            description:"The element in which the view will be inserted",
        },
        {
            name:"id",
            type:"string",
            description:"the view id attribute value",
        },
        {
            name:"className",
            type:"string",
            description:"the view class attribute value",
        },
        {
            name:"style",
            type:"string|CSSStyleDeclaration",
            description:"the view style attribute value",
        },
        {
            name:"tag",type:"string",
            description:`default to "div"`,
        },
        atProp,
    ],
    methods:[
        innateHTMLMethod,
        {
            name:"beforeEndHTML",
            type:"string",
            description:"inserts safely HTML or XML markup at the end of the element"
        },
        {
            name:"afterBeginHTML",
            type:"string",
            description:"inserts safely HTML or XML markup at the beginning of the element",
        },
        {
            name:"adjacentTo",
            type:"(element:Element,before?:boolean):View",
            description:"Inserts the view before or after an element and returns the current view",
            props:[
                {
                    name:"element",type:"Element",
                    description:"Element before/after which the view is inserted",
                },
                {
                    name:"before",type:"boolean",
                    description:"if true the view is inserted before the element otherwise after. @default to false",
                },
            ],
        },
        {
            name:"substitute",
            type:"(substitute:Node):Node",
            description:`
                Replaces the view by another node and returns the substitute
                @same result as using replaceWith
            `,
        },
    ],
};
